import React from "react";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";
import DraftNumberInput from "../../../inputs/DraftNumberInput";
import { Checkbox, FormControlLabel} from "@material-ui/core";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const JobBasedProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: {
  product: ProductOptionInterface;
  onRemove: () => void;
  onProductChange: (updatedProduct: ProductOptionInterface) => void;
  editable: boolean;
  baselineProfile: string;
  deploymentType: string;
}) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.currentTarget;
    if (product?.properties && name) {
      const productCopy = { ...product };
      productCopy.properties = { ...productCopy.properties };
      productCopy.properties[name] = !productCopy.properties[name];
      onProductChange(productCopy);
    }
  };

    const handleProfileChange = (newProfile: string) => {
      const productCopy = { ...product, profile: newProfile };
      onProductChange(productCopy);
    };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={!!product?.properties?.externalOrchestrator}
            onChange={handleCheckboxChange}
            name="externalOrchestrator"
          />
        }
        label="Connect to external Orchestrator"
      />
      <FlexSection>
        <DraftNumberInput
          label="Number of Skills"
          product={product}
          field="numberOfSkills"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
        <DraftNumberInput
          label="Number of Concurrent Pipelines"
          product={product}
          field="numberOfPipelines"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default JobBasedProductWidget;
